import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    business: null,
    upload: null
  },
  mutations: {
    user (state, value) { state.user = value },
    business (state, value) { state.business = value },
    upload (state, value) { state.upload = value }
  },
  actions: {
    openUpload: (context, data) => {
      if (context.state.upload) return false
      context.commit('upload', data)
      return true
    }
  }
})
